/* eslint-disable react-hooks/exhaustive-deps */
import { Alert, Button, Form, Select } from "antd";
import { FormInstance } from "antd/es/form/Form";
import { useAtom } from "jotai";
import React, { useEffect, useState, createRef } from "react";

import { exchangeGroupCollectionAtom } from "lib/core-react/store/store";
import {
  useGetExchangeGroup,
  useGetExchangeGroupCustomers,
  useUpdateExchangeGroupCustomer,
} from "lib/core-react/hooks/private/useExchangeGroup";

import {
  ExchangeGroupCollectionModel,
  ExchangeGroupModel,
} from "models/exchangeGroupCollectionModel";
import { IExchangeGroupUserRequest } from "types/exchangeGroupCollection";

import { renderOptionsFromEnum } from "components/Form/forms";
import { CustomerUserModel } from "models/customerUserCollectionModel";

interface IProps {
  setIsShowUpdateModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectedCustomerUser: CustomerUserModel;
  data: ExchangeGroupModel;
}

const UpdateExchangeGroupCustomer = ({
  setIsShowUpdateModal,
  selectedCustomerUser,
  data,
}: IProps) => {
  const { getExchangeGroupCustomers } = useGetExchangeGroupCustomers(data.id);
  const { getExchangeGroup } = useGetExchangeGroup();
  const [
    { data: exchangeGroupCollectionDataAtom, isLoading: exchangeGroupLoading },
  ] = useAtom(exchangeGroupCollectionAtom);

  const { updateExchangeGroupCustomer, isLoading, isError } =
    useUpdateExchangeGroupCustomer();
  const [isErrorVisible, setIsErrorVisible] = useState(false);

  const formRef: React.Ref<FormInstance<any>> = createRef();
  const [form] = Form.useForm();

  useEffect(() => {
    return () => {
      form.resetFields();
    };
  }, [selectedCustomerUser, form]);

  //hide error message after 5 sec
  useEffect(() => {
    if (isErrorVisible) {
      setTimeout(() => {
        setIsErrorVisible(false);
      }, 5000);
    }
  }, [isErrorVisible]);

  useEffect(() => {
    getExchangeGroup();
  }, []);

  const ExchangeGroupCollectionData =
    exchangeGroupCollectionDataAtom &&
    new ExchangeGroupCollectionModel(exchangeGroupCollectionDataAtom);

  const onFinish = async (value: IExchangeGroupUserRequest) => {
    const payload = {
      user_id: selectedCustomerUser.getId(),
      exchange_group_id: Number(value.exchange_group_id),
    };

    try {
      await updateExchangeGroupCustomer(payload as IExchangeGroupUserRequest);
      await getExchangeGroupCustomers();
      setIsShowUpdateModal(false);
      setIsErrorVisible(false);
    } catch (error) {
      setIsErrorVisible(true);
    }
  };

  return (
    <Form
      onFinish={onFinish}
      form={form}
      layout="vertical"
      name="Update-Exchange-Group-Customer"
      ref={formRef}
      initialValues={{
        exchange_group_id: {
          label: data.getName(),
          value: data.getId(),
        },
      }}
    >
      <Form.Item
        rules={[{ required: true, message: "Exchange group is required" }]}
        name="exchange_group_id"
        label="Exchange Group"
      >
        <Select
          loading={exchangeGroupLoading}
          placeholder="Please select an exchange group"
        >
          {ExchangeGroupCollectionData?.getExchangeGroupIdsAsObject() &&
            renderOptionsFromEnum(
              ExchangeGroupCollectionData?.getExchangeGroupIdsAsObject(),
            )}
        </Select>
      </Form.Item>

      <Form.Item>
        <Button
          loading={isLoading}
          type="primary"
          htmlType="submit"
          style={{ width: "100%" }}
        >
          Submit
        </Button>
      </Form.Item>

      {isErrorVisible && (
        <Alert
          style={{ marginTop: "7px" }}
          message={isError}
          closable
          afterClose={() => setIsErrorVisible(false)}
          type="error"
          showIcon
        />
      )}
    </Form>
  );
};

export default UpdateExchangeGroupCustomer;
